"use client"

import { SourceOptionDropdowns } from "@/components/source-option-dropdowns"
import { useTranslations } from "next-intl"

const TYPES = ["all", "videos", "animated"] as const

interface RealbooruFilterTabsProps {
  type: string
  onTypeChange: (value: string) => void
}

// Realbooru's Type: everything, videos only, or animated only (the site's `video` and `animated` tags); see lib/booru-sources/booru-api/realbooru.ts.
export function RealbooruFilterTabs({ type, onTypeChange }: RealbooruFilterTabsProps) {
  const t = useTranslations("realbooruFilterTabs")
  return (
    <SourceOptionDropdowns
      groups={[{ id: "type", label: t("type"), value: type, defaultValue: "all", options: TYPES.map((value) => ({ value, label: t(value) })) }]}
      onChange={(_, value) => onTypeChange(value)}
    />
  )
}
